<template>
  <vx-card no-shadow>
    <vs-input
      type='password'
      class="w-full mb-base"
      label-placeholder="Old Password"
      v-model="old_password"
    />
    <vs-input
      type='password'
      class="w-full mb-base"
      label-placeholder="New Password"
      @input="validatePassword()"
      v-model="new_password"
    />
    <p v-if="passwordValidator.noLowerCase" class="passwordError">
      You need at least one lower case character
    </p>
    <p v-if="passwordValidator.noUpperCase" class="passwordError">
      You need at least one upper case character
    </p>
    <p v-if="passwordValidator.noNumbers" class="passwordError">
      You need at least one number
    </p>
    <p v-if="passwordValidator.tooShort" class="passwordError">
      Your password must be at lease 8 characters long
    </p>

    <vs-input
      type='password'
      class="w-full mb-base"
      label-placeholder="Confirm Password"
      v-model="confirm_new_password"
    />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="savePassword()"
        >Save Changes</vs-button
      >
      <vs-button class="ml-4 mt-2" type="border">Close</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
      email: "",
      deliveryAddress: "",
      deliveryName: "",
      deliveryPhone: "",
      passwordValidator: {
        noLowerCase: false,
        noUpperCase: false,
        noNumbers: false,
        tooShort: false,
      },
    };
  },
  mounted() {
    this.getUserDetails();
  },
  methods: {
    savePassword() {
      this.validatePassword();
      if (this.old_password == "")
        this.alertUser("danger", "please enter your old password");
      else if (this.invalidPassword())
        this.alertUser("danger", "please enter a valid password");
      else if (this.confirm_new_password == "")
        this.alertUser("danger", "Please confirm your password");
      else if (this.new_password != this.confirm_new_password)
        this.alertUser(
          "danger",
          "Password and confirmation password do not match"
        );
      else this.setNewPassword();
    },
    invalidPassword() {
      return (
        this.passwordValidator.tooShort ||
        this.passwordValidator.noLowerCase ||
        this.passwordValidator.noUpperCase ||
        this.passwordValidator.noNumbers
      );
    },
    setNewPassword() {
      this.showLoadingSpinner();
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/saveCustomerSettings"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      let newSettings = {
        old_password: this.old_password,
        password: this.new_password,
        email: this.email,
        delivery_address: this.deliveryAddress,
        contact_name: this.deliveryName,
        contact_phone: this.deliveryPhone,
      };

      fetch(urlWithParams.href, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newSettings),
      })
        .then((response) => response.json())
        .then((data) => {
          if (!this.encounteredErrors(data)) {
            this.alertUser("success", "User settings saved!");
            this.old_password = "";
            this.new_password = "";
            this.confirm_new_password = "";
          }
          this.hideLoadingSpinner();
        });
    },
    validatePassword() {
      const lowerCaseLetters = /[a-z]/g;
      const upperCaseLetters = /[A-Z]/g;
      const numbers = /[0-9]/g;

      this.passwordValidator.noLowerCase = !this.new_password.match(
        lowerCaseLetters
      );
      this.passwordValidator.noUpperCase = !this.new_password.match(
        upperCaseLetters
      );
      this.passwordValidator.noNumbers = !this.new_password.match(numbers);
      this.passwordValidator.tooShort = !(this.new_password.length >= 8);
    },
  },
};
</script>

<style scoped>
.passwordError {
  color: red;
}
</style>